module.exports = __webpack_public_path__ + "empty.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/assets/img/empty.png
// module id = 2182
// module chunks = 13